var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-body-help" }, [
      _c("div", { staticClass: "top" }, [
        _c("p", { staticClass: "title" }, [_vm._v("帮助中心")]),
        _c("a", { attrs: { href: "/manual", target: "_blank" } }, [
          _vm._v("更多")
        ])
      ]),
      _c("div", { staticClass: "content" }, [
        _vm._v("\n        content...\n    ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f7c9916", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f7c9916","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/con-box/src/right/help.vue
// module id = lkYb
// module chunks = 28